import { Center } from '../../lib/types/models/center/center'
import {
  AssignJourneyToCenterRequestInput,
  CenterRequestInput
} from '../../lib/types/models/center/center-input'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CreateCenterAndAssignJourneysInput = AssignJourneyToCenterRequestInput & CenterRequestInput

export const createCenterAndAssignJourneys = (input: CreateCenterAndAssignJourneysInput) => {
  return restApiClient
    .url(API.centers.createAndAssignJourneys.url)
    .post<Center, CreateCenterAndAssignJourneysInput>(input)
}
